import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=45ac741e&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=45ac741e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac741e",
  null
  
)

export default component.exports